module.exports = __webpack_public_path__ + "img/microsoft-excel-icon.e94e0807.png";